import React from 'react';
import { Container } from '@mui/material';

interface IContainerWrapper {
    children: JSX.Element;
    /**
     * AppLayout already offsets main content by the sidebar width. Set true for public UGC/campaign
     * detail so the hero can sit flush with that edge (no second 65px inset).
     */
    disableLegacyInset?: boolean;
}

const ContainerWrapper: React.FC<IContainerWrapper> = ({ children, disableLegacyInset = false }) => {
    return (
        <Container
            maxWidth={false}
            disableGutters
            sx={{
                zIndex: 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                gap: '30px',
                width: '100%',
                maxWidth: 'min(100%, 100dvw)',
                overflowX: 'hidden',
                /** Let page grow past one viewport so tall dashboards (e.g. BuzzBridge) scroll fully */
                minHeight: '100vh',
                boxSizing: 'border-box',
                /** AppLayout already offsets main by sidebar width; extra margin clips content on the right */
                marginLeft: 0,
                paddingTop: disableLegacyInset ? 0 : { xs: '20px', lg: '0px' },
            }}>
            {children}
        </Container>
    );
};

export { ContainerWrapper };
